export default __webpack_public_path__ + "static/chess2-88c5f8248828e8d9bb709ff24e04976f.png";